import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { GetEnumValuesDto, ImportanceLevelDay } from 'src/app/core/api/models';

import { DialogService } from 'src/app/core/services/dialog.service';
import { BaseFormPageComponent } from 'src/app/pages/shared/base';
import { BaseFormModule } from 'src/app/shared/components/base/base-component/base-form.module';

@Component({
  selector: 'app-alert-setting',
  templateUrl: './alert-setting.component.html',
  imports: [BaseFormModule],
})
export class AlertSettingComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region properties
  model: ImportanceLevelDay = {};
  @Input() notificationImportanceLevel;
  @Input() counter: number;
  @Input()
  notificationImportanceLevels: GetEnumValuesDto[];
  @Input() modelItems: any[] = [];

  @Output('items') output_Items = new EventEmitter<any>();

  //#endregion

  constructor(
    protected dialogService: DialogService,
    protected translate: TranslateService
  ) {
    super();
  }

  ngOnInit(): void {
    this.model = Object.assign({}, this.modelItems[this.counter]);
  }

  initForm(): void {}

  emitItems() {
    this.model.fromDaysMoreThanSendFrequently = Number(
      this.model.fromDaysMoreThanSendFrequently
    );
    this.model.toDaysMoreThanSendFrequently = Number(
      this.model.toDaysMoreThanSendFrequently
    );
    this.model.importanceLevel = this.notificationImportanceLevel.key;
    this.output_Items.emit(this.model);
  }
}
